export default "__VITE_ASSET__cbbc8488__"